import { createSlice } from '@reduxjs/toolkit'

// ---------------------------------------------------------------------------
// Passphrase word list: 645 everyday English words (nouns, adjectives, verbs),
// hand-curated to exclude anything ambiguous, offensive, or hard to spell.
// 645 words gives ~9.33 bits of entropy per word (log2(645)), so a 5-word
// passphrase already clears ~46 bits — comfortably "Strong" on our own meter
// — while every word stays short and easy to type on a phone keyboard.
// ---------------------------------------------------------------------------
const PASSPHRASE_WORDS = ['almond', 'alpaca', 'amber', 'amble', 'anchor', 'ancient', 'apple', 'apricot', 'archer', 'arrow', 'artist', 'ascend', 'ash', 'aurora', 'author', 'azure', 'badger', 'baker', 'banana', 'banker', 'banner', 'barley', 'basil', 'basket', 'bat', 'bay', 'beacon', 'bear', 'beaver', 'beige', 'berry', 'biscuit', 'bison', 'blanket', 'blend', 'bloom', 'blossom', 'bold', 'bottle', 'boulder', 'bounce', 'bracelet', 'branch', 'brave', 'breeze', 'bright', 'brisk', 'bronze', 'bucket', 'buffalo', 'build', 'builder', 'butcher', 'cabbage', 'cabin', 'calm', 'camel', 'candle', 'cannon', 'canvas', 'canyon', 'cape', 'captain', 'caramel', 'carpenter', 'carpet', 'carrot', 'carve', 'cashew', 'castle', 'cauldron', 'cave', 'cavern', 'celery', 'chalice', 'chameleon', 'charcoal', 'chase', 'chemist', 'cherry', 'chest', 'chestnut', 'chicken', 'chili', 'chisel', 'cinnamon', 'clay', 'clever', 'cliff', 'climb', 'cloak', 'cloud', 'clove', 'coast', 'cobalt', 'cobbler', 'coconut', 'coffee', 'comet', 'compass', 'copper', 'coral', 'cosmic', 'cottage', 'crab', 'craft', 'cranberry', 'crane', 'cream', 'creek', 'crimson', 'crisp', 'crow', 'crown', 'cucumber', 'curator', 'currant', 'cushion', 'cyan', 'dagger', 'dance', 'dancer', 'dapper', 'daring', 'dart', 'dash', 'date', 'dawn', 'dazzling', 'deer', 'delta', 'desert', 'diver', 'doctor', 'dolphin', 'donkey', 'dove', 'dream', 'dreamy', 'drift', 'driver', 'drizzle', 'drowsy', 'drum', 'duck', 'dune', 'dusk', 'eager', 'eagle', 'earnest', 'easel', 'editor', 'elegant', 'elk', 'ember', 'emerald', 'engine', 'explore', 'falcon', 'farmer', 'fearless', 'fennel', 'fern', 'ferry', 'fetch', 'fierce', 'fig', 'finch', 'fisher', 'flag', 'flame', 'flask', 'flicker', 'float', 'florist', 'flow', 'fly', 'fog', 'forager', 'forest', 'forester', 'forge', 'fortress', 'fountain', 'fox', 'frog', 'frost', 'frosty', 'fuchsia', 'gadget', 'galaxy', 'gale', 'gallery', 'garden', 'gardener', 'garlic', 'gate', 'gather', 'gauge', 'gear', 'gecko', 'gentle', 'ginger', 'glacier', 'glide', 'globe', 'glow', 'glowing', 'goat', 'goblet', 'golden', 'goose', 'graceful', 'grape', 'gravel', 'gray', 'gritty', 'grouse', 'grow', 'guard', 'guide', 'gull', 'hammer', 'harbor', 'hardy', 'hare', 'harness', 'hasty', 'hawk', 'hazelnut', 'hedgehog', 'helmet', 'hen', 'herb', 'heron', 'hidden', 'hinge', 'honey', 'horizon', 'horse', 'hourglass', 'hover', 'humble', 'hunt', 'hunter', 'hut', 'icy', 'iguana', 'indigo', 'ink', 'island', 'ivory', 'jade', 'jagged', 'jaguar', 'jar', 'jewel', 'jeweler', 'jolly', 'journey', 'jubilant', 'judge', 'jungle', 'keen', 'keeper', 'kettle', 'key', 'kindle', 'knight', 'ladder', 'lagoon', 'lake', 'lamp', 'lantern', 'latch', 'launch', 'lavender', 'lawyer', 'leaf', 'leap', 'lemon', 'lentil', 'lettuce', 'lever', 'lighthouse', 'lightning', 'lilac', 'lime', 'linger', 'lion', 'lively', 'lizard', 'llama', 'lobster', 'locket', 'loom', 'lucky', 'lush', 'lynx', 'lyre', 'magenta', 'magpie', 'mango', 'mansion', 'map', 'maple', 'march', 'maroon', 'marsh', 'mask', 'mason', 'mast', 'mauve', 'meadow', 'mechanic', 'medal', 'mellow', 'melon', 'mend', 'merchant', 'merry', 'meteor', 'mighty', 'millet', 'miner', 'mint', 'mirror', 'mist', 'misty', 'modest', 'mold', 'mole', 'monk', 'monsoon', 'moon', 'moose', 'mosaic', 'moss', 'mountain', 'mule', 'mural', 'mushroom', 'mustard', 'navy', 'nebula', 'needle', 'net', 'newt', 'nimble', 'noble', 'nurse', 'nurture', 'nutmeg', 'oar', 'oasis', 'oat', 'ochre', 'octopus', 'olive', 'onion', 'orange', 'orb', 'orbit', 'oregano', 'ornate', 'otter', 'owl', 'paddle', 'paint', 'painter', 'palace', 'panther', 'papaya', 'parcel', 'parrot', 'parsley', 'parsnip', 'patient', 'peach', 'peanut', 'pear', 'pearl', 'pebble', 'pecan', 'pelican', 'pendant', 'peninsula', 'pepper', 'petal', 'pheasant', 'pier', 'pigeon', 'pillar', 'pilot', 'pineapple', 'pipe', 'pistachio', 'placid', 'planet', 'plant', 'plateau', 'playful', 'plover', 'plum', 'plumber', 'poet', 'polish', 'polished', 'pond', 'pony', 'possum', 'potato', 'potter', 'pouch', 'pounce', 'prairie', 'priest', 'printer', 'prism', 'proud', 'pulley', 'puma', 'pumpkin', 'quail', 'quick', 'quiet', 'quill', 'quince', 'quiver', 'rabbit', 'raccoon', 'race', 'radiant', 'radish', 'raft', 'rain', 'rainbow', 'raisin', 'ramble', 'ranger', 'rapid', 'rare', 'raspberry', 'raven', 'ray', 'reap', 'reed', 'reef', 'render', 'restless', 'ribbon', 'ridge', 'river', 'roam', 'robin', 'roll', 'rooster', 'root', 'rope', 'rosemary', 'ruby', 'rugged', 'rust', 'rustic', 'sacred', 'saddle', 'saffron', 'sage', 'sail', 'sailor', 'salamander', 'salmon', 'sand', 'sapphire', 'satchel', 'scarlet', 'scatter', 'scholar', 'scout', 'scramble', 'scribe', 'scroll', 'sculpt', 'sculptor', 'seal', 'sentinel', 'serene', 'shady', 'shark', 'sharp', 'sheep', 'shepherd', 'shield', 'shimmer', 'shiny', 'shore', 'shovel', 'shrew', 'shrimp', 'sickle', 'silent', 'silver', 'sketch', 'skip', 'skunk', 'sleek', 'sleepy', 'slide', 'smith', 'smoke', 'smoky', 'snow', 'snug', 'soar', 'soil', 'soldier', 'solemn', 'spark', 'sparkle', 'sparkling', 'sparrow', 'spear', 'spin', 'spinach', 'spindle', 'sprint', 'spry', 'squash', 'squid', 'squirrel', 'stack', 'star', 'statue', 'steady', 'stork', 'storm', 'stormy', 'stout', 'stove', 'strawberry', 'stream', 'stroll', 'sturdy', 'subtle', 'sugar', 'summit', 'sunny', 'sunrise', 'sunset', 'surge', 'surgeon', 'swallow', 'swamp', 'swan', 'sweep', 'swift', 'swirl', 'tailor', 'tan', 'tangerine', 'tapestry', 'teacher', 'teal', 'telescope', 'tender', 'tent', 'tern', 'thorn', 'thrifty', 'throne', 'thunder', 'thyme', 'tiger', 'tiny', 'toad', 'tomato', 'torch', 'tortoise', 'totem', 'toucan', 'tower', 'trace', 'trader', 'trail', 'tranquil', 'trapper', 'traveler', 'trek', 'trellis', 'trident', 'trot', 'trumpet', 'trunk', 'tundra', 'turkey', 'turnip', 'turquoise', 'turtle', 'tutor', 'twilight', 'umbrella', 'urn', 'valley', 'vanilla', 'vast', 'vault', 'vendor', 'venture', 'vessel', 'vibrant', 'villager', 'vine', 'violet', 'violin', 'vivid', 'volcano', 'voyage', 'wagon', 'walnut', 'walrus', 'wander', 'warden', 'warm', 'warrior', 'waterfall', 'weathered', 'weave', 'weaver', 'welder', 'wetland', 'whale', 'wheat', 'wheel', 'whirl', 'whisk', 'whistle', 'wild', 'wind', 'windmill', 'wise', 'witty', 'wolf', 'writer', 'yam', 'zealous']

// Adjective + noun pool for the username generator's "word + number" style.
// Kept intentionally small and clean (no adjectives/nouns that could combine
// into anything awkward) since usernames are semi-public, unlike passwords.
const USERNAME_ADJECTIVES = ['swift', 'silent', 'bright', 'calm', 'bold', 'clever', 'quiet', 'brave', 'quick', 'gentle', 'lucky', 'noble', 'sunny', 'misty', 'golden', 'silver', 'crimson', 'azure', 'amber', 'cosmic']
const USERNAME_NOUNS = ['otter', 'falcon', 'maple', 'comet', 'harbor', 'summit', 'ember', 'willow', 'raven', 'meadow', 'canyon', 'lantern', 'voyager', 'orbit', 'thistle', 'granite', 'cascade', 'juniper', 'nimbus', 'quartz']

// ---------------------------------------------------------------------------
// Crack-time estimator
//
// Methodology (disclosed on-page too, for transparency): we assume an
// offline attacker who already has a stolen password hash and can attempt
// 10 billion guesses per second — a commonly-cited benchmark for a modern
// GPU rig cracking a fast, unsalted hash. We estimate average crack time as
// half the full keyspace (an attacker expects to find the password halfway
// through an exhaustive search on average). This is deliberately a
// conservative, worst-case-for-the-user estimate: a slow, well-salted hash
// (bcrypt/Argon2) would take far longer to crack than shown here, but we'd
// rather under-promise on security than over-promise.
// ---------------------------------------------------------------------------
const GUESSES_PER_SECOND = 10_000_000_000

const formatCrackTime = (seconds) => {
  if (!isFinite(seconds) || seconds < 0) return 'Unknown'
  if (seconds < 1) return 'Instantly'
  const units = [
    { label: 'second', secs: 1 },
    { label: 'minute', secs: 60 },
    { label: 'hour', secs: 3600 },
    { label: 'day', secs: 86400 },
    { label: 'month', secs: 2629800 },
    { label: 'year', secs: 31557600 },
  ]
  const YEAR = 31557600
  if (seconds < YEAR) {
    for (let i = units.length - 1; i >= 0; i--) {
      const val = seconds / units[i].secs
      if (val >= 1) {
        const rounded = Math.round(val)
        return `${rounded} ${units[i].label}${rounded === 1 ? '' : 's'}`
      }
    }
    return 'Instantly'
  }
  const years = seconds / YEAR
  const AGE_OF_UNIVERSE_YEARS = 13_800_000_000
  if (years >= AGE_OF_UNIVERSE_YEARS * 1000) return 'Longer than the universe has existed, many times over'
  if (years >= AGE_OF_UNIVERSE_YEARS) return 'Longer than the age of the universe'
  if (years >= 1_000_000_000) return `${(years / 1_000_000_000).toFixed(1)} billion years`
  if (years >= 1_000_000) return `${(years / 1_000_000).toFixed(1)} million years`
  if (years >= 1_000) return `${Math.round(years / 1000)} thousand years`
  return `${Math.round(years)} years`
}

const calcEntropyAndCrackTime = (charsetSize, length) => {
  if (!charsetSize || !length) return { bits: 0, crackTime: 'Unknown' }
  const bits = length * Math.log2(charsetSize)
  const combinations = Math.pow(2, bits)
  const avgSeconds = combinations / 2 / GUESSES_PER_SECOND
  return { bits: Math.round(bits), crackTime: formatCrackTime(avgSeconds) }
}

const initialState = {
  // Which generator mode is active on the page
  generatorMode: 'password', // 'password' | 'passphrase' | 'username'

  // ---- Character-based password ----
  length: 16,
  includeUppercase: true,
  includeLowercase: true,
  includeNumbers: true,
  includeSymbols: true,
  excludeAmbiguous: false,
  minNumbers: 1,
  minSymbols: 1,
  baseWord: '',
  password: '',
  passwords: [],
  strength: 'weak',
  entropyBits: 0,
  crackTime: '',
  bulkCount: 5,

  // ---- Passphrase ----
  passphraseWordCount: 5,
  passphraseSeparator: '-',
  passphraseCapitalize: true,
  passphraseIncludeNumber: true,
  passphrase: '',
  passphraseEntropyBits: 0,
  passphraseCrackTime: '',

  // ---- Username ----
  usernameStyle: 'word-number', // 'word-number' | 'plus-address'
  baseEmail: '',
  username: '',
  usernames: [],

  // ---- Session-only generator history (cleared on refresh, never sent anywhere) ----
  history: [],
}

const pushHistory = (state, value, type) => {
  state.history.unshift({ value, type, id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}` })
  if (state.history.length > 20) state.history.length = 20
}

const passwordSlice = createSlice({
  name: 'password',
  initialState,
  reducers: {
    setGeneratorMode: (state, action) => {
      state.generatorMode = action.payload
    },

    // ---- Character password controls ----
    setLength: (state, action) => {
      state.length = action.payload
    },
    setIncludeUppercase: (state, action) => {
      state.includeUppercase = action.payload
    },
    setIncludeLowercase: (state, action) => {
      state.includeLowercase = action.payload
    },
    setIncludeNumbers: (state, action) => {
      state.includeNumbers = action.payload
    },
    setIncludeSymbols: (state, action) => {
      state.includeSymbols = action.payload
    },
    setExcludeAmbiguous: (state, action) => {
      state.excludeAmbiguous = action.payload
    },
    setMinNumbers: (state, action) => {
      state.minNumbers = action.payload
    },
    setMinSymbols: (state, action) => {
      state.minSymbols = action.payload
    },
    setBaseWord: (state, action) => {
      // Letters + digits only, capped so it can never exceed the password length
      state.baseWord = action.payload.replace(/[^a-zA-Z0-9]/g, '').slice(0, 20)
    },
    setBulkCount: (state, action) => {
      state.bulkCount = action.payload
    },

    generatePassword: (state) => {
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const lowercase = 'abcdefghijklmnopqrstuvwxyz'
      const numbers = '0123456789'
      const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?'
      const ambiguous = '0O1lI'

      let charset = ''
      if (state.includeUppercase) charset += uppercase
      if (state.includeLowercase) charset += lowercase
      if (state.includeNumbers) charset += numbers
      if (state.includeSymbols) charset += symbols

      if (state.excludeAmbiguous) {
        charset = charset.split('').filter(char => !ambiguous.includes(char)).join('')
      }

      if (!charset) {
        state.password = ''
        state.strength = 'weak'
        state.entropyBits = 0
        state.crackTime = ''
        return
      }

      const numberPool = (state.excludeAmbiguous ? numbers.replace(/[01]/g, '') : numbers).split('')
      const symbolPool = symbols.split('')
      const randomFrom = (pool) => pool[Math.floor(Math.random() * pool.length)]

      // 1. Fill the password with cryptographically-plain randomness from the charset
      let chars = []
      for (let i = 0; i < state.length; i++) {
        chars.push(charset.charAt(Math.floor(Math.random() * charset.length)))
      }

      // 2. "With Requirements" - guarantee the minimum number/symbol counts the
      // user asked for. Done as one deterministic pass (not two independent
      // "keep swapping until satisfied" loops) so that satisfying the symbol
      // minimum can never accidentally overwrite a position that was already
      // quietly satisfying the number minimum, or vice versa.
      const targetNumbers = state.includeNumbers ? Math.min(state.minNumbers, state.length) : 0
      // Symbols are capped to whatever room is left after the number
      // requirement, so a combination like "12 numbers + 12 symbols" on a
      // 16-character password can never be an impossible ask - numbers keep
      // priority since that control sits first in the UI.
      const targetSymbols = state.includeSymbols
        ? Math.min(state.minSymbols, Math.max(0, state.length - targetNumbers))
        : 0

      const digitIndices = []
      const symbolIndices = []
      chars.forEach((c, i) => {
        if (numbers.includes(c)) digitIndices.push(i)
        else if (symbols.includes(c)) symbolIndices.push(i)
      })

      // Positions that already naturally satisfy each requirement are locked
      // first, so neither requirement's top-up step can touch them.
      const lockedForNumbers = new Set(digitIndices.slice(0, targetNumbers))
      const lockedForSymbols = new Set(symbolIndices.slice(0, targetSymbols))
      const locked = new Set([...lockedForNumbers, ...lockedForSymbols])

      const freeIndices = chars.map((_, i) => i).filter(i => !locked.has(i))
      // Shuffle the free positions so top-ups land in random slots
      for (let i = freeIndices.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
          ;[freeIndices[i], freeIndices[j]] = [freeIndices[j], freeIndices[i]]
      }

      let needNumbers = targetNumbers - lockedForNumbers.size
      while (needNumbers > 0 && freeIndices.length) {
        const idx = freeIndices.pop()
        chars[idx] = randomFrom(numberPool)
        needNumbers--
      }
      let needSymbols = targetSymbols - lockedForSymbols.size
      while (needSymbols > 0 && freeIndices.length) {
        const idx = freeIndices.pop()
        chars[idx] = randomFrom(symbolPool)
        needSymbols--
      }

      // 3. "With Name" - embed the user's word/name at a random position.
      // This trades some security for memorability, which is exactly why the
      // UI shows a strength warning whenever baseWord is set.
      if (state.baseWord && state.baseWord.length < state.length) {
        const maxStart = state.length - state.baseWord.length
        const start = Math.floor(Math.random() * (maxStart + 1))
        for (let i = 0; i < state.baseWord.length; i++) {
          chars[start + i] = state.baseWord[i]
        }
      }

      const password = chars.join('')
      state.password = password

      // Strength label (unchanged categorical meter, kept for continuity)
      let strengthScore = 0
      if (state.length >= 12) strengthScore++
      if (state.length >= 16) strengthScore++
      if (state.includeUppercase) strengthScore++
      if (state.includeLowercase) strengthScore++
      if (state.includeNumbers) strengthScore++
      if (state.includeSymbols) strengthScore++
      if (state.baseWord) strengthScore = Math.max(0, strengthScore - 2) // embedded word = weaker, be honest about it

      if (strengthScore <= 2) state.strength = 'weak'
      else if (strengthScore <= 4) state.strength = 'fair'
      else if (strengthScore <= 5) state.strength = 'strong'
      else state.strength = 'very-strong'

      // Time-to-crack transparency feature
      const { bits, crackTime } = calcEntropyAndCrackTime(charset.length, state.length)
      state.entropyBits = bits
      state.crackTime = crackTime

      pushHistory(state, password, 'Password')
    },

    generateMultiplePasswords: (state, action) => {
      const count = action.payload || state.bulkCount || 5
      const originalPassword = state.password
      state.passwords = []

      for (let i = 0; i < count; i++) {
        passwordSlice.caseReducers.generatePassword(state)
        state.passwords.push(state.password)
      }

      state.password = originalPassword
    },
    clearPasswords: (state) => {
      state.passwords = []
    },

    // ---- Passphrase controls ----
    setPassphraseWordCount: (state, action) => {
      state.passphraseWordCount = action.payload
    },
    setPassphraseSeparator: (state, action) => {
      state.passphraseSeparator = action.payload
    },
    setPassphraseCapitalize: (state, action) => {
      state.passphraseCapitalize = action.payload
    },
    setPassphraseIncludeNumber: (state, action) => {
      state.passphraseIncludeNumber = action.payload
    },
    generatePassphrase: (state) => {
      const words = []
      for (let i = 0; i < state.passphraseWordCount; i++) {
        let word = PASSPHRASE_WORDS[Math.floor(Math.random() * PASSPHRASE_WORDS.length)]
        if (state.passphraseCapitalize) word = word.charAt(0).toUpperCase() + word.slice(1)
        words.push(word)
      }
      let passphrase = words.join(state.passphraseSeparator)
      if (state.passphraseIncludeNumber) {
        passphrase += state.passphraseSeparator + Math.floor(Math.random() * 90 + 10)
      }
      state.passphrase = passphrase

      // Entropy: each word is drawn independently from the 645-word list.
      // The trailing 2-digit number adds roughly log2(90) more bits.
      const wordBits = state.passphraseWordCount * Math.log2(PASSPHRASE_WORDS.length)
      const numberBits = state.passphraseIncludeNumber ? Math.log2(90) : 0
      const bits = Math.round(wordBits + numberBits)
      const combinations = Math.pow(2, bits)
      const avgSeconds = combinations / 2 / GUESSES_PER_SECOND
      state.passphraseEntropyBits = bits
      state.passphraseCrackTime = formatCrackTime(avgSeconds)

      pushHistory(state, passphrase, 'Passphrase')
    },

    // ---- Username controls ----
    setUsernameStyle: (state, action) => {
      state.usernameStyle = action.payload
    },
    setBaseEmail: (state, action) => {
      state.baseEmail = action.payload.trim()
    },
    generateUsername: (state) => {
      let result = ''
      if (state.usernameStyle === 'plus-address' && state.baseEmail.includes('@')) {
        const [localPart, domain] = state.baseEmail.split('@')
        const tag = Math.random().toString(36).slice(2, 8)
        result = `${localPart}+${tag}@${domain}`
      } else {
        const adj = USERNAME_ADJECTIVES[Math.floor(Math.random() * USERNAME_ADJECTIVES.length)]
        const noun = USERNAME_NOUNS[Math.floor(Math.random() * USERNAME_NOUNS.length)]
        const num = Math.floor(Math.random() * 900 + 100)
        result = `${adj}${noun}${num}`
      }
      state.username = result
      if (!state.usernames.includes(result)) {
        state.usernames = [result, ...state.usernames].slice(0, 10)
      }
      pushHistory(state, result, 'Username')
    },
    clearUsernames: (state) => {
      state.usernames = []
    },

    // ---- History ----
    clearHistory: (state) => {
      state.history = []
    },
  },
})

export const {
  setGeneratorMode,
  setLength,
  setIncludeUppercase,
  setIncludeLowercase,
  setIncludeNumbers,
  setIncludeSymbols,
  setExcludeAmbiguous,
  setMinNumbers,
  setMinSymbols,
  setBaseWord,
  setBulkCount,
  generatePassword,
  generateMultiplePasswords,
  clearPasswords,
  setPassphraseWordCount,
  setPassphraseSeparator,
  setPassphraseCapitalize,
  setPassphraseIncludeNumber,
  generatePassphrase,
  setUsernameStyle,
  setBaseEmail,
  generateUsername,
  clearUsernames,
  clearHistory,
} = passwordSlice.actions

export default passwordSlice.reducer